import React, { useState, useEffect} from "react";
import { FaCalendarAlt, FaFileAlt } from "react-icons/fa";
// import { connect } from "react-redux";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import LoadMoreList from "../../../services/LoadMoreList";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl } from "../../../services/GlobalUrls";

const PoliciesAndProceduresMobile = ({ policiesList, ...props }) => {
  const [setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    // no-op: policiesList is used directly via filterRows
  }, [policiesList]);
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  //   Filter - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (policiesDetails) => {
    const searchText = inputValue.toLowerCase();
    return (
      policiesDetails.policy_created_date.toLowerCase().includes(searchText) ||
      policiesDetails.policies_and_procedures_policy_name
        .toLowerCase()
        .includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filterRows = policiesList ? policiesList.filter(matchesSearchText) : [];
  //   Filter - End
  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
        <div className="container">
          <div className="row">
            <div class="col-sm-12">
              {/* <label class="form-control-label text-right" for="search">
                Search
              </label> */}
              <div class="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  class="form-control"
                  placeholder="Enter here"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRows}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(policiesDetails, i) => (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark">
                  <FaCalendarAlt className="mr-1 text-primary" style={{ display: "inline", marginRight: "4px" }} />{" "}
                  {policiesDetails.policy_created_date}
                </li>
                <li className="text-dark">
                  <FaFileAlt className="mr-1 text-primary" style={{ display: "inline", marginRight: "4px" }} />{" "}
                  {policiesDetails.policies_and_procedures_policy_name}
                  {policiesDetails.policy_document && (
                    <a
                      onClick={() =>
                        viewFileModal(
                          constants.IMAGE_URL + policiesDetails.policy_document,
                          policiesDetails.policies_and_procedures_policy_name
                        )
                      }
                      className={
                        "text-" +
                        (policiesDetails.policy_document.endsWith(".png") ||
                        policiesDetails.policy_document.endsWith(".jpg") ||
                        policiesDetails.policy_document.endsWith(".jpeg") ||
                        policiesDetails.policy_document.endsWith(".pdf")
                          ? "primary"
                          : "primary") +
                        " text-sm pull-right mt--2"
                      }
                    >
                      <u>View File</u>
                    </a>
                  )}
                </li>
              </ul>
            )}
          />
        </div>
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"Policy Document - " + fileName}
      />
    </React.Fragment>
  );
};

export default PoliciesAndProceduresMobile;
